import { render, staticRenderFns } from "./adapting.vue?vue&type=template&id=8f715ca4&scoped=true&"
import script from "./adapting.vue?vue&type=script&lang=js&"
export * from "./adapting.vue?vue&type=script&lang=js&"
import style0 from "./adapting.vue?vue&type=style&index=0&id=8f715ca4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f715ca4",
  null
  
)

export default component.exports